export const extractEventAndMarketIds = (
  items: Array<{
    pidLid?: string;
    eventId: string;
    marketId: string;
    isBetBuilder?: boolean;
    betBuilderOutcomes?: Array<{ pidLid?: string }>;
  }>,
  isShareBetEnterCode: boolean,
  isBetBuilderActive: boolean,
): { eventsIds: string[]; marketsIds: string[] } => {
  return items.reduce(
    (acc, bet) => {
      const { pidLid = '', isBetBuilder = false, betBuilderOutcomes = [] } = bet;
      const isBetBuilderWithOutcomes =
        isBetBuilder && Boolean(betBuilderOutcomes.length) && isBetBuilderActive;

      if (isBetBuilderWithOutcomes) {
        const pidLidSet = new Set<string>(acc.marketsIds);
        betBuilderOutcomes.forEach((o) => {
          if (o.pidLid) {
            pidLidSet.add(o.pidLid);
          }
        });
        acc.marketsIds = Array.from(pidLidSet);
        acc.eventsIds.push(bet.eventId);
        return acc;
      }

      const eventId = isShareBetEnterCode ? bet.eventId : pidLid.split('.').slice(0, 2).join('.');
      const marketId = isShareBetEnterCode ? bet.marketId : pidLid;

      acc.eventsIds.push(eventId);
      acc.marketsIds.push(marketId);

      const isPrematchEvent = eventId.startsWith('1.');

      if (isPrematchEvent) {
        const [, eId] = eventId.split('.');
        const [, ...mId] = marketId.split('.');

        acc.eventsIds.push(`2.${eId}`);
        acc.marketsIds.push(`2.${mId.join('.')}`);
      }

      return acc;
    },
    { eventsIds: [], marketsIds: [] } as { eventsIds: string[]; marketsIds: string[] },
  );
};
